import React from 'react'
import { extractVariables } from '../../utils/configVariables'

const HighlightedPreview = ({ originalValue, processedValue, configs }) => {
    const variables = extractVariables(originalValue)

    if (variables.length === 0) {
        return <span className="text-gray-600 dark:text-gray-400">{processedValue}</span>
    }

    // Build a map of variable names to their values
    const varMap = {}
    configs.forEach(cfg => {
        varMap[cfg.key] = cfg.value
    })

    // Track which parts of processedValue should be highlighted
    const highlights = []

    // For each variable, find where its value appears in processedValue
    variables.forEach((varName) => {
        const varValue = varMap[varName]
        if (varValue) {
            let searchStart = 0
            let idx
            while ((idx = processedValue.indexOf(varValue, searchStart)) !== -1) {
                highlights.push({
                    start: idx,
                    end: idx + varValue.length,
                    varName,
                })
                searchStart = idx + varValue.length
            }
        }
    })

    // Sort highlights by start position
    highlights.sort((a, b) => a.start - b.start)

    // Build parts array
    const parts = []
    let lastEnd = 0

    highlights.forEach((highlight) => {
        // Add text before highlight
        if (lastEnd < highlight.start) {
            parts.push({
                type: 'text',
                content: processedValue.substring(lastEnd, highlight.start),
                key: `text-${lastEnd}`,
            })
        }

        // Add highlighted part
        parts.push({
            type: 'variable',
            content: processedValue.substring(highlight.start, highlight.end),
            key: `var-${highlight.varName}-${highlight.start}`,
        })

        lastEnd = highlight.end
    })

    // Add remaining text
    if (lastEnd < processedValue.length) {
        parts.push({
            type: 'text',
            content: processedValue.substring(lastEnd),
            key: `text-final`,
        })
    }

    return (
        <span>
            {parts.map((part) => (
                part.type === 'variable' ? (
                    <span
                        key={part.key}
                        className="bg-blue-50 dark:bg-blue-950/30 text-blue-700 dark:text-blue-400 font-semibold px-1 rounded"
                    >
                        {part.content}
                    </span>
                ) : (
                    <span key={part.key} className="text-gray-600 dark:text-gray-400">
                        {part.content}
                    </span>
                )
            ))}
        </span>
    )
}

export default HighlightedPreview
